export default class BaseModel {
  public id: string | null = null
}
